import React from 'react'

const PREP_COLOR = '#3b82c4'

export function DotScale({ min, max, labels, value, onChange, disabled }) {
  const dots = []
  for (let i = min; i <= max; i++) dots.push(i)
  const selected = value?.value ?? null
  return (
    <div style={styles.wrap}>
      <div style={styles.row}>
        {dots.map((n) => {
          const isSelected = selected === n
          return (
            <button
              key={n}
              style={{
                ...styles.dot,
                ...(isSelected ? { background: PREP_COLOR, borderColor: PREP_COLOR, color: '#fff' } : {}),
                ...(disabled ? styles.disabled : {}),
              }}
              onClick={() => !disabled && onChange({ value: n, label: labels[n] })}
              disabled={disabled}
              aria-pressed={isSelected}
              aria-label={labels[n]}
            >
              {n}
            </button>
          )
        })}
        {selected && <span style={styles.label}>{labels[selected]}</span>}
      </div>
    </div>
  )
}

const styles = {
  wrap: { padding: '12px 14px' },
  row: { display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' },
  dot: {
    width: '28px', height: '28px', borderRadius: '50%',
    border: `1.5px solid #bcc8d8`, background: 'transparent',
    fontSize: '12px', fontWeight: 500, cursor: 'pointer',
    color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center',
    flexShrink: 0, transition: 'background var(--duration-fast) ease, border-color var(--duration-fast) ease',
  },
  disabled: { cursor: 'default', opacity: 0.7 },
  label: { fontSize: '12px', color: 'var(--text-secondary)', marginLeft: '6px' },
}
